module.exports = __webpack_public_path__ + "static/media/m6.38e858c6.png";